import React from "react";
import '../Styles/components/Loading.css'
import Logo from '../Images/Milaaz1.png'

function Loading () {

    return (

        <React.Fragment>
            
            <div className="Loading">
                <img src={Logo} alt="Loading"/>
            <div class="container">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            </div>

        </React.Fragment>
    )
}

export default Loading